import React from 'react';
import './LeftSidebar.css';

const LeftSidebar = ({ isOpen, onClose }) => {
  const chatHistory = [
    'Website Development Project',
    'Mobile App Design',
    'AI Chatbot Integration',
    'Digital Marketing Campaign',
    'SAP ERP Consultation'
  ];

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <div className={`left-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h3>Chat History</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="chat-history">
          {chatHistory.map((chat, index) => (
            <div key={index} className="chat-item">
              <span className="chat-icon">💬</span>
              <span className="chat-text">{chat}</span>
            </div>
          ))}
        </div>

        <div className="sidebar-section">
          <h4>Products</h4>
          <div className="sidebar-link">View All Products</div>
        </div>

        <div className="sidebar-section">
          <h4>AI Tools & Options</h4>
          <div className="sidebar-link">AI Assistant</div>
          <div className="sidebar-link">Automation Tools</div>
          <div className="sidebar-link">Analytics Dashboard</div>
        </div>

        <div className="social-links">
          <h4>Connect With Us</h4>
          <div className="social-icons-list">
            <a href="https://www.linkedin.com/company/gentrobyte-ai-labs/" target="_blank" rel="noopener noreferrer" className="social-icon-item linkedin">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
              </svg>
              <span className="social-link-text">LinkedIn</span>
            </a>
            <a href="https://www.instagram.com/gentrobyte/" target="_blank" rel="noopener noreferrer" className="social-icon-item instagram">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/>
              </svg>
              <span className="social-link-text">Instagram</span>
            </a>
            <a href="https://www.youtube.com/channel/UCbdMOvwpKgI5KQ4FkIiphgQ" target="_blank" rel="noopener noreferrer" className="social-icon-item youtube">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              <span className="social-link-text">YouTube</span>
            </a>
            <a href="https://api.whatsapp.com/send?phone=919159247730" target="_blank" rel="noopener noreferrer" className="social-icon-item whatsapp">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              <span className="social-link-text">WhatsApp</span>
            </a>
            <a href="https://x.com/gentrobyte" target="_blank" rel="noopener noreferrer" className="social-icon-item twitter">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <span className="social-link-text">X (Twitter)</span>
            </a>
            <a href="https://www.facebook.com/gentrobyte" target="_blank" rel="noopener noreferrer" className="social-icon-item facebook">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <span className="social-link-text">Facebook</span>
            </a>
            <a href="https://www.google.com/search?q=Gentrobyte+AI+Labs" target="_blank" rel="noopener noreferrer" className="social-icon-item google">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M21.8 10.2H12v3.6h5.5c-.2 1.4-1.5 4.2-5.5 4.2-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16 3.3 13.2 2 11 2 6.5 2 2.5 6 2.5 11.5S6.5 21 12 21c6 0 9.8-4.1 9.8-9.8 0-.6-.1-1.3 0-1z"/>
              </svg>
              <span className="social-link-text">Google Search</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftSidebar;
